import { render, staticRenderFns } from "./file-template-breadcrumb.vue?vue&type=template&id=5d07ef96&scoped=true"
import script from "./file-template-breadcrumb.vue?vue&type=script&lang=js"
export * from "./file-template-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./file-template-breadcrumb.vue?vue&type=style&index=0&id=5d07ef96&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d07ef96",
  null
  
)

export default component.exports